import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { useAuth } from '../../context/Auth';
import ErrorPage from '../ErrorPage/ErrorPage';
import { useLocation } from 'react-router-dom';
import { MobileBrowserAlert } from '../MobileBrowserAlert';
import { useMobile } from '../../context/Mobile';

export const PrivateRoute = ({ children }) => {
  const { user, inProgress } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { isMobile } = useMobile();

  const inLogout = location.pathname === '/logout';

  const signupRoutes = {
    CHOOSE_USERNAME: '/choose-username',
    CHOOSE_AVATAR: '/upload-image',
    SHOW_SIGNUP_SLIDES: '/welcome',
    CHOOSE_SUBSCRIPTION: '/choose-plan',
    SET_UI_MODE: '/choose-theme',
  };

  useEffect(() => {
    if (
      !inLogout &&
      user &&
      Object.keys(signupRoutes).includes(user?.signupStatus)
    ) {
      navigate(signupRoutes[user.signupStatus]);
    }
  }, []);

  if (inProgress) {
    return <></>;
  }

  if (
    !inLogout &&
    location.pathname !== '/mobile-alert' &&
    user?.signupStatus === 'COMPLETED' &&
    isMobile
  ) {
    return <MobileBrowserAlert />;
  }

  if (user != null) {
    return <>{children}</>;
  }

  return <ErrorPage code={403} />;
};
